const urlQueries = config.urlQueries;
export default urlQueries;